export default {"src":"/_next/static/media/transfer.5077d7dc.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};